import React, {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card,Alert, Col,Button, Form, Row, Spin, Radio, Modal,Grid, Space, Divider} from "antd";
import {ButtonContainer} from "../../../../MaterialsDetail/style";
import {LeftOutlined} from "@ant-design/icons";
import {MyButton, MyText} from "../../../../../components";
import {fetchScreeningOneTestAction, postScreeningOneTestAction, fetchScreeningRoutinesListAction} from "../../../../../utils/store/pages/screening";
import {fetchEvaluateAction, resetEvaluateAction, RootState, selectStore} from "../../../../../utils";

import { WarnIcon } from "../../../../../assets/icon/common/screening";
import { YesButton, NoButton, ButtonText } from "../../style";
import {useTranslation} from "react-i18next";
import { useEmbeddedNavigate } from "../../../../../utils/context/embed";

export const SelectedTestIdPage = () => {
  const {t} = useTranslation("common")

  const {testId, childId} = useParams();
  const {ageId} = useParams();
  

  const {name} = useParams();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [answers, setAnswers] = useState<{ [key: number]: number }>({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [unansweredQuestions, setUnansweredQuestions] = useState<number[]>([]);
  const [surveyName, setSurveyName] = useState<string | null>(null);
  const {screening: {oneTest: oneTestState}}:RootState = useSelector(selectStore);
  const { screening: { surveysList: surveysListState } }: RootState = useSelector(selectStore);
  const evaluate = useSelector((state: any) => state.materials?.evaluate ?? { loading: false });

  const routesIdxParam = searchParams.get("routesIdx");
  const routesIdx = routesIdxParam ? JSON.parse(routesIdxParam)[0] : null;
  const embeddedNavigate = useEmbeddedNavigate();

  const parsedRoutesIdx = JSON.parse(routesIdx);
  const rowRef = useRef<HTMLDivElement | null>(null);
  const isTablet = screens.md && !screens.xl && !screens.xxl;


  useEffect(() => {
    if(testId){
      dispatch(fetchScreeningOneTestAction({list_id: Number(testId), age: ageId * 12, survey_ids: parsedRoutesIdx}))
    }
  }, [testId])

  useEffect(() => {
        if (ageId) {
          dispatch(fetchScreeningRoutinesListAction({ age: ageId * 12, list_id: testId }));
        }
      }, [ageId]);

  useEffect(() => {
  if (routesIdx !== null && surveysListState?.data?.surveys) {
    const foundSurvey = surveysListState.data.surveys.find((item: any) => item.id === routesIdx);
    if (foundSurvey) {
      setSurveyName(foundSurvey.name);
    }
  }
}, [routesIdx, surveysListState]);

  const handleGoBack = () => {
    embeddedNavigate(-1)
  }

  const handleAnswerChange = (questionId: number, answerId: number) => {
    setAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: answerId }));
  };
  

  // const handleSubmit = async () => {
  //   const questions = oneTestState?.data || [];
  
  //   const unanswered = questions
  //     .filter((question) => !answers.hasOwnProperty(question.id))
  //     .map((question) => question.id);
  
  //   if (unanswered.length > 0) {
  //     setUnansweredQuestions(unanswered);
  //     setIsModalVisible(true);
  //   } else {
  //     const body = {
  //       // age: Number(ageId * 12),
  //       // name: name,
  //       child_id: childId,
  //       test_id: testId,
  //       answers: Object.entries(answers).map(([questionId, answerId]) => ({
  //         question_id: Number(questionId),
  //         answer_id: answerId,
  //       })),
  //     };
  
  //     // await dispatch(postScreeningOneTestAction(body));
  
  //     try {
  //       // const response = await fetchTestResults(1);
  //       // if (response && response.results && response.results.length > 0) {
  //       //   const testId = response.results[0].test_id; 
  //       //   navigate(`/results/testId/${testId}/type/1`);
  //       // } else {
  //       //   console.error("Список результатов пуст.");
  //       // }

  //       const response = await fetchEvaluate(body);
  //             if (response && response.user_test_id) {
  //               const testId = response.user_test_id;
  //               embeddedNavigate(`/results/testId/${testId}/type/1`);
  //             } else {
  //               console.error("Список результатов пуст.");
  //             }
  //     } catch (error) {
  //       console.error("Ошибка при получении данных:", error);
  //     }
  //   }
  // };

  const handleSubmit = () => {
    const questions = oneTestState?.data || [];

    const unanswered = questions
      .filter((question) => !answers.hasOwnProperty(question.id))
      .map((question) => question.id);

    if (unanswered.length > 0) {
      setUnansweredQuestions(unanswered);
      setIsModalVisible(true);
      return;
    }

    const body = {
      child_id: childId,
      test_id: testId,
      answers: Object.entries(answers).map(([questionId, answerId]) => ({
        question_id: Number(questionId),
        answer_id: answerId,
      })),
    };

    dispatch(fetchEvaluateAction(body));
  };

  useEffect(() => {
  if (!evaluate.success || !evaluate.data?.user_test_id) return;
    embeddedNavigate(`/results/testId/${evaluate.data.user_test_id}/type/1`);
  }, [evaluate.success, evaluate.data]);


  const handleModalOk = () => {
    const questions = oneTestState?.data || [];
    const firstUnansweredIndex = questions.findIndex(
      (question) => unansweredQuestions.includes(question.id)
    );
    if (firstUnansweredIndex !== -1) {
      setCurrentQuestionIndex(firstUnansweredIndex);
    }
    setIsModalVisible(false);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const getYearLabel = (age: any) => {
    const lastDigit = age % 10;
    const lastTwoDigits = age % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2");
    if (lastDigit === 1) return t("ages1");
    if (lastDigit >= 2 && lastDigit <= 4) return t("ages");
    return t("ages2");
  };

  const handleQuestionClick = (questionId: number) => {
    const questions = oneTestState?.data || [];
    const index = questions.findIndex((question) => question.id === questionId);
    if (index !== -1) {
      setCurrentQuestionIndex(index);
    }
    setIsModalVisible(false);
  };

  const handleForceSubmit = () => {
    const body = {
        age: Number(ageId * 12),
        test_id: testId,
        answers: Object.entries(answers).map(([questionId, answerId]) => ({
          question_id: Number(questionId),
          answer_id: answerId,
        })),
        onSuccess: () => {
          embeddedNavigate(`/screening/tests-list`);
        },
      };

    dispatch(postScreeningOneTestAction(body));
    setIsModalVisible(false);
  };

 useEffect(() => {
  const container = rowRef.current;
  const button = container?.children[currentQuestionIndex] as HTMLElement;

  if (container && button) {
    const containerWidth = container.offsetWidth;
    const buttonOffset = button.offsetLeft;
    const buttonWidth = button.offsetWidth;

    const scrollTo = buttonOffset - (containerWidth / 2) + (buttonWidth / 2);

    container.scrollTo({
      left: scrollTo,
      behavior: 'smooth',
    });
  }
}, [currentQuestionIndex]);

  const questions = oneTestState?.data || [];
  const currentQuestion = questions[currentQuestionIndex];

  return(
    

    <>
    <Row justify="center">
      <Col span={20}>
        {/* <Row align="middle" style={{marginBottom: 26, height: '60px'}}>
          <ButtonContainer onClick={handleGoBack}>
            <LeftOutlined style={{color: 'rgba(10, 3, 60, 0.7)'}}/>
          </ButtonContainer>
          <MyText color='rgba(19, 15, 38, 1)' size={26} weight={800}
                  style={{fontFamily: 'Nunito', display: 'block', marginLeft: 12}}>
            {`${t("selfDiagnosis")}`}
          </MyText>
        </Row> */}

        <Row align="middle" justify="space-between" style={{ marginBottom: 26, padding: '0px', height: screens.xs ? 'auto' : '60px' }}>
                      {screens.xs ? (
                        <>
                        <Col span={24} style={{marginBottom: 12}}>
                      
                        <Row align="middle">
                                                    <Col span={3}>
                                                      <ButtonContainer onClick={handleGoBack}>
                                                        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                                      </ButtonContainer>
                                                    </Col>
                                                    <Col span={21}>
                                                      <MyText
                                                        color="rgba(19, 15, 38, 1)"
                                                        size={26}
                                                        weight={800}
                                                        style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                                      >
                                                        {`${t("selfDiagnosis")}`}
                                                      </MyText>
                                                    </Col>
                        </Row>
                        </Col>
                                                
                        <Row style={{ background: '#fff', borderRadius: '16px', padding: '10px 16px', border: '1px solid rgba(229, 233, 242, 1)' }}>
                          <MyText color="rgba(10, 3, 60, 1)" weight={700} size={32} style={{ fontFamily: 'Nunito', lineHeight: '40px' }}>
                          {`${ageId} ${getYearLabel(ageId)}`}
                          </MyText>
                        </Row>
                        </>
                      ) : (
                        <>         
                        <Row align="middle">
        
                                                    <ButtonContainer onClick={handleGoBack}>
                                                      <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                                    </ButtonContainer>
                                                    <MyText
                                                      color="rgba(19, 15, 38, 1)"
                                                      size={32}
                                                      weight={800}
                                                      style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                                    >
                                                      {`${t("selfDiagnosis")}`}
                                                    </MyText>
                        </Row>
                                                
                        <Row style={{ background: '#fff', borderRadius: '16px', padding: '10px 16px', border: '1px solid rgba(229, 233, 242, 1)' }}>
                          <MyText color="rgba(10, 3, 60, 1)" weight={700} size={32} style={{ fontFamily: 'Nunito', lineHeight: '40px' }}>
                          {`${ageId} ${getYearLabel(ageId)}`}
                          </MyText>
                        </Row>
                        </>
                      )}
                    </Row>
          <Spin spinning={oneTestState?.loading}>
            <Row gutter={16}>
              {screens.xs && (

            <Col span={24} style={{marginBottom: 16}}>
                <Card style={{height:screens.xs ? 'auto' : "100%", borderRadius: '20px'}} styles={{ body: {height:screens.xs ? 'auto' : "100%"} }}>
                <Row style={{marginBottom: 12, marginLeft: 4}}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block' }}
                  >
                  {surveyName}
                  </MyText>
                </Row>
                <Row
                  justify="start"
                  ref={rowRef}
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    paddingBottom: 10,
                  }}
                >
                    {questions.map((question: any, index: any) => {
                      const isAnswered = answers.hasOwnProperty(question.id);
                      const isCurrent = index === currentQuestionIndex;

                      return (
                        <MyButton
                          key={question.id}
                          style={{
                            width: 40,
                            height: 40,
                            margin: 4,
                            backgroundColor: isCurrent
                              ? '#FF9800'
                              : isAnswered
                                ? '#00BDF4'
                                : '#fff',
                            color: isCurrent || isAnswered ? '#fff' : '#000',
                            border: isCurrent ? '2px solid #FF9800' : '1px solid #d9d9d9',
                          }}
                          onClick={() => setCurrentQuestionIndex(index)}
                        >
                          {index + 1}
                        </MyButton>
                      );
                    })}
                  </Row>

                  <Row justify="center" style={{ marginTop: 20 }}>
                    <MyButton color="orange" type="primary" onClick={handleSubmit}>
                    {`${t("finishTest")}`}
                    </MyButton>
                  </Row>
                </Card>
              </Col>

              )}
              <Col span={screens.xs ? 24 : 17}>
                <Card style={{height: screens.xs ? 'auto' : "100%", borderRadius: '20px'}} styles={{ body: {height: screens.xs ? 'auto' : "100%"} }}>
                  {currentQuestion ? (
                      <Form style={{height: screens.xs ? 'auto' : "100%"}}>
                        <Row justify="space-between" style={{flexDirection: 'column', height: screens.xs ? 'auto' : "100%"}}>
                          <Row justify="center">
                            <MyText weight={700} size={18}>{`${t("ask")}`} {currentQuestionIndex + 1}</MyText>
                          </Row>
                          <Divider style={{marginBottom: 16, marginTop: 16}}/>
                          <Form.Item>
                            {/* <Col style={{marginBottom: screens.xs ? 16 : 142, display: 'flex', justifyContent: 'center'}}> */}
                            <Col style={{marginBottom: screens.xs ? 16 : 142}}>
                              <MyText weight={800} size={screens.xs ? 24 : 32} style={{fontFamily: 'Nunito', textAlign: 'center', lineHeight: screens.xs ? '26px': '48px', height: '56px' }}>{currentQuestion.text.replace(/&nbsp;/g, ' ').replace(/<\/?p>/g, '')}</MyText>
                            </Col>
                            <Col span={24} style={{marginTop: 20}}>
                            
                            <Row justify="center" style={{ gap: screens.xs ? '20px' : '40px' }}>
                            {currentQuestion.answers.map((answer, index) => {
                              const ButtonComponent = answer.class === 'yes' ? YesButton : NoButton;

                              return (
                                <ButtonComponent
                                  // key={answer.id}
                                  key={`${currentQuestion.id}-${answer.id}`}
                                  onClick={() => {
                                    handleAnswerChange(currentQuestion.id, answer.id);
                                    if (currentQuestionIndex < questions.length - 1) {
                                      setCurrentQuestionIndex(currentQuestionIndex + 1);
                                    }
                                  }}
                                  isSelected={answers[currentQuestion.id] === answer.id}
                                  screens={screens}
                                >
                                  <ButtonText weight={700} size={screens.xs ? 16 : 32} color={answer.class === 'yes' ? 'rgba(0, 167, 75, 1)' : 'rgba(230, 101, 89, 1)'}>
                                    {answer.text}
                                  </ButtonText>
                                </ButtonComponent>
                              );
                            })}
                            </Row>
                            </Col>

                          </Form.Item>
                        </Row>
                      </Form>
                  ) : (
                    <Spin loading={!!currentQuestion} />
                  )}
                </Card>
                
                
              </Col>
              
              {screens.xs ? null : (
              <Col span={7}>
                <Card style={{height: "100%", borderRadius: '20px'}} styles={{ body: {height: "100%"} }}>
                  <Row justify="center" style={{marginBottom: 12}}>
                    <MyText
                      color="rgba(19, 15, 38, 1)"
                      size={24}
                      weight={800}
                      style={{ fontFamily: 'Nunito', display: 'block' }}
                    >
                    {surveyName}
                    </MyText>
                  </Row>
                  <Row justify="center">
                    {questions.map((question: any, index: any) => {
                      const isAnswered = answers.hasOwnProperty(question.id);
                      const isCurrent = index === currentQuestionIndex;

                      return (
                        <MyButton
                          key={question.id}
                          style={{
                            width: 40,
                            height: 40,
                            margin: 4,
                            backgroundColor: isCurrent
                              ? '#FF9800'
                              : isAnswered
                                ? '#00BDF4'
                                : '#fff',
                            color: isCurrent || isAnswered ? '#fff' : '#000',
                            border: isCurrent ? '2px solid #FF9800' : '1px solid #d9d9d9',
                          }}
                          onClick={() => setCurrentQuestionIndex(index)}
                        >
                          {index + 1}
                        </MyButton>
                      );
                    })}
                  </Row>

                  <Row justify="center" style={{ marginTop: 20 }}>
                    <MyButton color="orange" type="primary" onClick={handleSubmit} style={isTablet ? { whiteSpace: 'normal' } : undefined}>
                    {`${t("finishTest")}`}
                    </MyButton>
                  </Row>
                </Card>
              </Col>
              )}
            </Row>
            <Row style={{marginTop: '46px'}}>
                <Col span={screens.xs ? 24 : 17}>
                <Alert showIcon={true} icon={<WarnIcon width={24} height={24} alt={"blue-warn-icon"}/>}
                    message={`${t("readinessDescription")}`}
                  type="info"
                  style={{ fontSize: '18px' }}
                  />
              </Col>
                </Row>
          </Spin>
      </Col>
            
      <Modal
        title={t("unansweredQuestions")}
        open={isModalVisible}
        onCancel={handleModalCancel}
        footer={() => (
          <Row justify="center" gutter={[16,16]}>
            <MyButton type="primary" style={{marginRight: 8}} onClick={() => handleModalOk()}>Перейти к вопросу</MyButton>
            <MyButton color="orange" type="primary" disabled onClick={() => handleForceSubmit()}>Завершить тестирование</MyButton>
          </Row>
        )}
      >
        <p>Вы не ответили на следующие вопросы:</p>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {unansweredQuestions.map((questionId) => {
            const index = questions.findIndex((q) => q.id === questionId);
            return (
              <MyButton
                type="dashed"
                key={questionId}
                style={{
                  width: 40,
                  height: 40,
                  margin: 4,
                }}
                onClick={() => handleQuestionClick(questionId)}
              >
                {index + 1}
              </MyButton>
            );
          })}
        </div>
      </Modal>
    </Row>
    </>
  )
}